import {API} from '@/utils/api';
import {AxiosResponse} from "axios";
import {ApiListResponse} from "@/types/Common";
import {PUBLIC_URL} from "@/utils/url";
import {LIST_DEFAULT_SELECT} from '@/utils/defaults';
export class ListSelectService {

    static async fetchList<T>(
        endpoint: string,
        additionalParams: Record<string, string> = {},
        page: number = 0,
        limit: number = LIST_DEFAULT_SELECT
    ): Promise<ApiListResponse<T>> {
        try {
            const fetchURL = new URL(endpoint, PUBLIC_URL);

    fetchURL.searchParams.set('page', page.toString());
    fetchURL.searchParams.set('limit', limit.toString());

            Object.entries(additionalParams).forEach(([key, value]) => {
                fetchURL.searchParams.set(key, value);
            });


            const response: AxiosResponse<ApiListResponse<T>> = await API.get<ApiListResponse<T>>(fetchURL.href);
            return response.data;
        } catch (error) {
            console.error(`Wystąpił problem z pobieraniem danych z ${endpoint}:`, error);
            throw error;
        }
    }
}